'use strict';
/*
 ** Two geo locations {lat: ***, lng: ***}
 */
const getDistance = mapObj => {
  const center = mapObj.getCenter();
  const bounds = mapObj.getBounds();
  if (center && bounds) {
    var sw = bounds.getSouthWest();
    const p1 = { lat: center.lat(), lng: center.lng() };
    const p2 = { lat: sw.lat(), lng: sw.lng() };

    var R = 6378137; // Earth’s mean radius in meter
    var dLat = rad(p2.lat - p1.lat);
    var dLong = rad(p2.lng - p1.lng);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(rad(p1.lat)) *
        Math.cos(rad(p2.lat)) *
        Math.sin(dLong / 2) *
        Math.sin(dLong / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = (R * c) / 1000;
    return d; // returns the distance in km
  } else {
    return 1500;
  }
};

const rad = x => {
  return (x * Math.PI) / 180;
};

export default getDistance;
